import { render, staticRenderFns } from "./ModalPermissao.vue?vue&type=template&id=7032e1b2&"
import script from "./ModalPermissao.vue?vue&type=script&lang=js&"
export * from "./ModalPermissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports